import { httpRequest } from "@services/http";

export interface Feature {
  id: number;
  name: string;
  parent_id: number | null;
}

export class CommandCreateFeature {
  async run(payload: { name: string; parent_id?: number | null }): Promise<Feature> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/permissions/features/`;
    try {
      return await httpRequest<Feature>(url, { method: "POST", body: payload });
    } catch (error) {
      console.error("Error creating feature:", error);
      throw error;
    }
  }
}
